import { Typography } from '@mui/material';

export const CustomHtml = ({ id, value, updateValue, path, html, visible }) => {

  const htmlDecode = (input) => {
    var e = document.createElement('div');
    e.innerHTML = input;
    return e.childNodes.length === 0 ? "" : e.childNodes[0].nodeValue;
  }

  return (
    <div id={`#/properties/${path}`} className={path} style={{ display: visible ? 'block' : 'none' }}>
      {html &&
        <div dangerouslySetInnerHTML={{
          __html: html.replace('min-height: 100vh;', 'min-height: 100%;')
        }} />
      }
    </div>
  );
};
